<template>
  <admin-layout :sectionTitle="sectionTitle">
    <!--<div class="page-header">
      <div class="row align-items-end">
        <div class="col-sm mb-2 mb-sm-0">
          <h1 class="page-header-title">Utente</h1>
        </div>

        <div class="col-sm-auto">
          <button type="button" @click="onSubmit" :disabled="form.processing" class="btn btn-primary">Salva</button>
        </div>
      </div>
    </div>-->

    <div class="row">
      <div class="col-md-8 col-12">
        <div class="card mb-4">
          <div class="card-body">
            <!-- name -->
            <div class="form-group">
              <label>Nome</label>
              <input type="text" v-model="form.name" :class="{ 'is-invalid': form.errors.name }" class="form-control" />
              <span class="invalid-feedback d-block" v-if="form.errors.name" v-text="form.errors.name"></span>
            </div>

            <!-- email -->
            <div class="form-group">
              <label>Email</label>
              <input type="email" v-model="form.email" :class="{ 'is-invalid': form.errors.email }" class="form-control" />
              <span class="invalid-feedback d-block" v-if="form.errors.email" v-text="form.errors.email"></span>
            </div>

            <!-- password -->
            <div class="form-group">
              <label>Password</label>
              <input type="password" v-model="form.password" :class="{ 'is-invalid': form.errors.password }" class="form-control" />
              <span class="invalid-feedback d-block" v-if="form.errors.password" v-text="form.errors.password"></span>
            </div>

            <!-- password confirmation -->
            <div class="form-group">
              <label>Conferma password</label>
              <input type="password" v-model="form.password_confirmation" :class="{ 'is-invalid': form.errors.password_confirmation }" class="form-control" />
              <span class="invalid-feedback d-block" v-if="form.errors.password_confirmation" v-text="form.errors.password_confirmation"></span>
            </div>

            <!-- role -->
            <div class="form-group">
              <label>Ruolo</label>
              <select
                v-model="form.role_id"
                ref="role"
                class="js-select2-custom custom-select"
                size="1"
                data-hs-select2-options='{
                    "placeholder": "Scegli il ruolo",
                    "searchInputPlaceholder": "Cerca ruolo"
                }'
              >
                <option label="empty"></option>
                <option v-for="role in roles" :key="role.id" :value="role.id" v-text="role_labels[role.name]"></option>
              </select>
              <span class="invalid-feedback d-block" v-if="form.errors.role_id" v-text="form.errors.role_id"></span>
            </div>
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-sm-auto">
            <button type="button" @click="onSubmit" :disabled="form.processing" class="btn btn-primary">Salva</button>
          </div>
        </div>
      </div>
    </div>
  </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";

export default {
  components: {
    AdminLayout,
  },

  props: ['sectionTitle'],

  data() {
    return {
      roles: this.$page.props.roles,
      form: this.$inertia.form({
        id: null,
        name: null,
        email: null,
        password: null,
        password_confirmation: null,
        role_id: null,
      }),
      role_labels: {
        Admin: "Amministratore",
        Appraiser: "Perito",
        Agent: "Agente",
        Manager: "Manager",
        Collaborator: "Collaboratore",
        Project_manager: "Project Manager",
        Call_center: "Call Center"
      }
    };
  },

  computed: {
    method() {
      return this.form.id ? "put" : "post";
    },
  },

  mounted() {
    this.initForm();

    var select2 = $.HSCore.components.HSSelect2.init($(this.$refs.role));
    select2.on("select2:select", (e) => {
      this.form.role_id = e.params.data.id;
    });
  },

  watch: {
    "form.role_id": {
      immediate: true,
      handler(v) {
        $(this.$refs.role).val(v).trigger("change");
      },
    },
  },

  methods: {
    toggleUser(ev) {
      this.form.enable_user = ev.target.checked;
    },

    initForm() {
      let init = this.$page.props.editUser;

      for (let prop in init) {
        if (this.form.hasOwnProperty(prop)) {
          this.$set(this.form, prop, init[prop]);
        }
      }
    },

    onSubmit() {
      this.form.submit(this.method, this.$page.props.source);
    },
  },
};
</script>
